import * as z from 'zod';
import { validationMessagesMap } from 'src/utils/messages';
import { AGGREGATION_TYPE, MEASUREMENT_TYPE } from 'src/features/billableMetrics/utils/types';
import { VALID_AGGREGATIONS_BY_MEASUREMENT } from 'src/features/billableMetrics/utils/constants';

export type BillableMetricFormSchemaValues = z.infer<typeof billableMetricFormSchema>;

/*
 * The aggregation has to belong to the measurement type - the backend answers a mismatched pair with
 * `400 invalid_aggregation_for_measurement_type`. The form resets the aggregation when the
 * measurement changes, so this only fires if that reset is ever bypassed.
 */
export const billableMetricFormSchema = z
    .object({
        name: z.string().max(256).nonempty(),
        code: z.string().max(64).nonempty(),
        measurement_type: z.enum(MEASUREMENT_TYPE),
        aggregation_type: z.enum(AGGREGATION_TYPE),
        description: z.string().optional().nullable(),
        unit: z.string().optional().nullable(),
        is_active: z.boolean(),
    })
    .superRefine((data, ctx) => {
        if (!VALID_AGGREGATIONS_BY_MEASUREMENT[data.measurement_type].includes(data.aggregation_type)) {
            ctx.addIssue({
                path: ['aggregation_type'],
                code: 'custom',
                message: validationMessagesMap.validationErrorRequired,
            });
        }
    });
